import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "m42.184 37.941-9.364-9.364a14.56 14.56 0 0 0 2.39-8.003c0-8.083-6.553-14.636-14.636-14.636S5.938 12.491 5.938 20.574 12.49 35.21 20.574 35.21a14.56 14.56 0 0 0 8.004-2.391l9.364 9.364zM8.937 20.574c0-6.417 5.22-11.636 11.636-11.636s11.636 5.22 11.636 11.636-5.22 11.636-11.636 11.636S8.937 26.99 8.937 20.574" }) }) })
});
export default SvgSearch;
